import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { CsModalModule } from '@cargos/cs-modal';
import { SharedModule } from 'src/app/shared';
import { SharedDirectivesModule } from 'src/app/shared/directives/shared-directives.module';
import { AcceptanceLegalTermsModule } from 'src/app/shared/modules/acceptance-legal-terms/acceptance-legal-terms.module';
import { AuthLogoComponent } from 'src/app/shared/modules/logo/auth-logo/auth-logo.component';
import { VersionLabelComponent } from 'src/app/shared/modules/version-update/version-label/version-label.component';
import { ConfirmDispatcherProfileActivationComponent } from './confirm-dispatcher-profile-activation/confirm-dispatcher-profile-activation.component';
import { LoginComponent } from './login.component';


@NgModule({
    declarations: [
        LoginComponent,
        ConfirmDispatcherProfileActivationComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        CsModalModule,
        SharedDirectivesModule,
        SharedModule,
        AcceptanceLegalTermsModule,
        MatSnackBarModule,
        AuthLogoComponent,
        VersionLabelComponent,
    ],
    exports: [
        LoginComponent
    ],
    providers: []
})
export class LoginModule { }
